import Vue from 'vue'
import Router from 'vue-router'
import perm from '@/components/perm'
import enums from '@/components/enums' 

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/admin/jspframe/%2Ferp%2Fdashboard%2Fdashboard'
    },
    {
      path: '/receiveAccessToken',
      name: 'receiveAccessToken',
      component: resolve => require(['@/components/accessToken'], resolve),// 另一种写法 () => import('@/components/accessToken')
      props: (route) => ({ accessToken: route.query['access_token'], redirectRoutePath: route.query['redirectRoutePath'] })
    },
    {
      path: '/admin',
      component: resolve => require(['@/views/index'], resolve),      
      beforeEnter: (to, from, next) => {        
        //向后台获得所有权限列表才能进入路由，不然会导致权限未加载，但元素先过滤掉了
        perm.getPermPaths(function(){
          enums.getEnums(next);
        });
      },
      children: [

        /** jspframe for old jsp functions begin */
        {
          path: 'jspframe/:src',
          component: resolve => require(['@/components/jspframe'], resolve),
          props: true
        },
        /** jspframe for old jsp functions end */

        /** customer/resneeded begin */
        {
          path: 'customer/resneeded',
          component: resolve => require(['@/views/customer/resneeded'], resolve)
        },
        {
          path: 'customer/resneeded/edit/:id',
          component: resolve => require(['@/views/customer/resneeded/edit.vue'], resolve),
          props: (route) => ({ id: route.params.id, edit: route.query.showonly?false:true })
        },
        /** customer/resneeded end */
        
        /** /file/testResneeded begin */
        {
          path: 'file/testResneeded',
          component: resolve => require(['@/views/file/testResneeded'], resolve)
        },
        {
          path: 'file/testResneeded/edit/:id',
          component: resolve => require(['@/views/file/testResneeded/edit.vue'], resolve),
          props: (route) => ({ id: route.params.id, edit: route.query.showonly?false:true })
        },
        /** /file/testResneeded end */


        /** /data/attachment begin */
        {
          path: 'data/attachment',
          component: resolve => require(['@/views/data/attachment'], resolve)
        },
        {
            path: 'data/attachment/add',
            component: resolve => require(['@/views/data/attachment/edit.vue']),
        },
        {
          path: 'data/attachment/edit/:id',
          component: resolve => require(['@/views/data/attachment/edit.vue'], resolve),
          props: (route) => ({ id: route.params.id, edit: route.query.showonly?false:true })
        },
        /** /data/attachment end */

        /** /customer/recentMessageCount begin */
        {
          path: 'customer/recentMessageCount',
          component: resolve => require(['@/views/customer/recentMessageCount'], resolve)
        },
        {
          path: 'customer/recentMessageCount/edit/:id',
          component: resolve => require(['@/views/customer/recentMessageCount/edit.vue'], resolve),
          props: (route) => ({ id: route.params.id, edit: route.query.showonly?false:true })
        },
        /** /customer/recentMessageCount end */

        /** /omnicart/apiChannel begin */
        {
          path: 'omnicart/apiChannel',
          component: resolve => require(['@/views/omnicart/apiChannel'], resolve)
        },
        {
          path: 'omnicart/apiChannel/edit/:id',
          component: resolve => require(['@/views/omnicart/apiChannel/edit.vue'], resolve),
          props: (route) => ({ id: route.params.id, edit: route.query.showonly?false:true })
        },
        /** /omnicart/apiChannel end */

        /** /paypal/paypalTransation begin */
        {
          path: 'paypal/paypalTransation',
          component: resolve => require(['@/views/paypal/paypalTransation'], resolve)
        },
        {
          path: 'paypal/paypalTransation/edit/:id',
          component: resolve => require(['@/views/paypal/paypalTransation/edit.vue'], resolve),
          props: (route) => ({ id: route.params.id, edit: route.query.showonly?false:true })
        },
        /** /paypal/paypalTransation end */        

        /** /newegg/neweggOrder begin */
        {
          path: 'newegg/neweggOrder',
          component: resolve => require(['@/views/newegg/neweggOrder'], resolve)
        },
        {
          path: 'newegg/neweggOrder/edit/:id',
          component: resolve => require(['@/views/newegg/neweggOrder/edit.vue'], resolve),
          props: (route) => ({ id: route.params.id, edit: route.query.showonly?false:true })
        },
        /** /newegg/neweggOrder end */

      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js